import type { ApiParams, AptiRequestConfig } from "@/lib/types/api";
import type { BaseItem, GroupedItem, PatientAcuityScore, UUID } from "@/core/types";
import { httpAuth } from "@/utils/axios";

export type ReasoningOptionsResponse = GroupedItem<BaseItem>[];

export type PostAcuityScorePayload = {
  additional_details?: string;
  reasoning: string;
  score: PatientAcuityScore;
};

export type PostAcuityScoreResponse = { success: boolean };

export const acuityScoreRequestsTyped = {
  get_reasoning_options: function ({
    params,
  }: { params?: ApiParams } = {}): Promise<ReasoningOptionsResponse> {
    const config = {
      method: "GET",
      params,
      preventAllErrorToast: true,
      url: "/v1/acuity_score/reasoning_options",
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<ReasoningOptionsResponse>;
  },

  post_acuity_score: function ({
    data,
    params,
    patientId,
  }: {
    data: PostAcuityScorePayload;
    params?: ApiParams;
    patientId: UUID;
  }): Promise<PostAcuityScoreResponse> {
    const config = {
      data,
      method: "POST",
      params,
      preventAllErrorToast: true,
      url: `/v1/acuity_score/request/${patientId}`,
    } satisfies AptiRequestConfig;

    return httpAuth(config) as unknown as Promise<PostAcuityScoreResponse>;
  },
};
